import { format, parseISO } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';
import { DATE_FORMATS } from '@/constants';

export const formatDate = (
  date: string | Date | undefined | null,
  formatType: string = DATE_FORMATS.FULL_DATE,
  timezone?: string | null
): string => {
  if (!date) return '';

  if (timezone) {
    const dateWithTimezone = toZonedTime(date, timezone);

    return formatDate(dateWithTimezone, formatType);
  }

  if (date instanceof Date) {
    return format(date, formatType);
  }

  return format(parseISO(date), formatType);
};

export const resetTimeOnDate = (date: Date): Date => {
  date.setHours(0);
  date.setMinutes(0);
  date.setSeconds(0);

  return date;
};
